// The charts draw candles and bars with ctx.roundRect, which Safari only
// gained in 16. The iPhones that cannot go past iOS 15 (6s, 7, first-gen SE)
// threw on the first candle and the Analysis page showed "This page failed to
// load". A plain arcTo version stands in where the browser has none.

type Radii = number | DOMPointInit | (number | DOMPointInit)[] | undefined;

function firstRadius(r: Radii): number {
  if (typeof r === 'number') return r;
  if (Array.isArray(r)) return firstRadius(r[0] as Radii);
  if (r && typeof r === 'object') return Number((r as DOMPointInit).x) || 0;
  return 0;
}

if (typeof CanvasRenderingContext2D !== 'undefined' && !(CanvasRenderingContext2D.prototype as any).roundRect) {
  (CanvasRenderingContext2D.prototype as any).roundRect = function roundRect(
    this: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, radii?: Radii,
  ) {
    if (w < 0) { x += w; w = -w; }
    if (h < 0) { y += h; h = -h; }
    const r = Math.max(0, Math.min(firstRadius(radii), w / 2, h / 2));
    this.moveTo(x + r, y);
    this.arcTo(x + w, y, x + w, y + h, r);
    this.arcTo(x + w, y + h, x, y + h, r);
    this.arcTo(x, y + h, x, y, r);
    this.arcTo(x, y, x + w, y, r);
    this.closePath();
  };
}

export {};
